<template>
  <div class="role-manage">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left">
            <img
              class="icon"
              src="@/assets/images/public/public_add.png"
              @click="addRole(), FormDialogClass='system.AddRole'"
              alt
            />
          </div>
          <div class="c-u-right"></div>
        </template>
        <template slot="center">
          <el-table :data="roleList" style="width: 100%" height="100%" v-loading="loading">
            <el-table-column prop="name" :label="$t('system.RoleName')" width="200"></el-table-column>
            <el-table-column prop="remark" :label="$t('system.RoleRemark')"></el-table-column>
            <el-table-column :label="$t('system.Operate')" width="180">
              <template slot-scope="scope">
                <div class="operation">
                  <img
                    class="icon"
                    src="@/assets/images/public/public_authority.png"
                    @click="accessLayout(scope.$index, scope.row)"
                    alt
                  />
                  <img
                    class="icon"
                    src="@/assets/images/public/public_delete.png"
                    @click="handleDelete(scope.$index, scope.row)"
                    alt
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </enfold-uc>
    </enfold>
    <form-dialog
      :dialogVisible="FormDialogVisible"
      @closeDialog="FormCloseDialog"
      :title="$t(FormDialogClass)"
      dWidth="500px"
    >
      <div class="form-dialog">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="106px">
          <el-form-item :label="$t('system.RoleName')" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('system.RoleRemark')" prop="remark">
            <el-input v-model="addForm.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('system.RightConfig')" prop="authority">
            <el-checkbox-group v-model="addForm.authority">
              <el-checkbox :label="item.title" name="authority" v-for="(item,index) in authorityList" :key="index"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="el-form-submit">
            <el-button @click="resetForm('addForm')" round>{{$t('basics.Cancel')}}</el-button>
            <el-button type="primary" @click="submitForm('addForm')" round>{{$t('basics.Confirm')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('system.DelRole')">
      <div class="dd-dialog">{{$t('system.DeleteRole')}}?</div>
    </del-dialog>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import FormDialog from '@/components/basics/FormDialog'
import DelDialog from '@/components/basics/DelDialog'
export default {
  name: "RoleManage",
  data() {
    return {
      FormDialogVisible: false,
      FormDialogClass: "system.AddRole",
      DelDialogVisible: false,
      roleList: [],
      loading: true,
      delRoleId: "",
      addForm: {
        name: '',
        remark: '',
        authority: [],
      },
      rules: {
        name: [
          { required: true, message: this.$t('csrm1'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('csrm2'), trigger: 'blur' }
        ],
        authority: [
          { type: 'array', required: true, message: this.$t('csrm3'), trigger: 'change' }
        ]
      },
      // authorityList: ['系统管理', '日志管理', '设备管理', '素材管理', '模板管理', '播单管理', '发布管理', '系统配置', '消息管理']
      authorityList: [],
      parentList: []
    }
  },
  created() {
    this.getRoleList();
  },
  methods: {
    FormCloseDialog(type) {
      this.FormDialogVisible = false;
      if (type) {
        console.log(this.addForm);
      }
    },
    getRoleList() {
      this.$http.post("/admin/access/roleList", {}, data => {
        this.roleList = data;
        this.loading = false;
      });
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post("/admin/access/delRole", { id: this.delRoleId }, data => {
          console.log(data);
          this.getRoleList();
        });
      }
      this.DelDialogVisible = false;
    },
    addRole() {
      this.getNodeList();
      this.FormDialogVisible = true;
    },
    getNodeList() {
      this.$http.post("/admin/access/nodeList", {}, data => {
        // console.log(data[0].child);
        this.authorityList = data[0].child;
        this.parentList = data[0];
      });
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      // console.log(index, row);
      this.delRoleId = row.id;
      this.DelDialogVisible = true;
    },
    accessLayout(index, row) {
      console.log(index, row);
      this.$router.push({
        name: 'AccessLayout',
        params: {
          id: row.id
        }
      });
    },
    submitForm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          let ids = [];
          this.addForm.authority.forEach((item) => {
            let child = this.authorityList.find((node) => node.title === item);
            if (child !== -1) {
              ids.push(child.id);
            }
          });
          ids.push(this.parentList.id);
          this.$http.post("/admin/access/addRole", { name: this.addForm.name, remark: this.addForm.remark, node_ids: ids.join() }, data => {
            console.log(data);
            this.getRoleList();
          });
          this.FormDialogVisible = false;
          this.resetForm(addForm);
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(addForm) {
      this.FormDialogVisible = false;
      this.$refs[addForm].resetFields();
    }
  },
  components: {
    enfold,
    FormDialog,
    DelDialog,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.role-manage {
  width: 100%;
  height: 100%;
  .form-dialog {
    .el-checkbox {
      width: 110px;
      margin-right: 0px;
    }
  }
  /deep/ .cell {
    font-size: 16px;
  }
  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
    th:last-child > .cell {
      text-align: center;
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .el-form-submit {
    /deep/ .el-form-item__content {
      margin-left: 149px !important;
      .el-button {
        margin-left: 45px;
      }
    }
  }
  .dd-dialog {
    font-size: 16px;
    padding: 40px 0px;
    text-align: center;
  }
  .icon {
    width: 30px;
  }
}
</style>